import { Helmet } from 'react-helmet-async';
import BookingManagementView from './components/BookingManagementView';
import {
  PageTitleWrapper,
  PageHeader,
  showErrorMessage,
} from '../../shared/components/index';
import {
  Grid,
  Container,
  Button,
  TextField,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import { useEffect, useState, MouseEvent } from 'react';
import { useNavigate } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { getTenantBookingData, setSelectedBooking } from './services/bookingManagement.service';
import * as bookingService from './services/bookingManagement.service';
import * as assetGroupService from 'src/modules/Asset-group/services/asset-groupManagement.service';
import { selectUserState } from 'src/auth/login/services/userSlice';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useTranslation } from 'react-i18next';
import {
  BOOKING_STATUS_ENUM,
  COLOR_CODE,
  I18N,
  LIST_VIEW,
} from '../../shared/constants/constants';
import * as assetService from 'src/modules/Asset/services/assetManagement.service';
import * as ROUTES from '../../shared/constants/routes';
import { VIEW_TYPE } from './utils/utils';
import { useLocation, useSearchParams } from 'react-router-dom';
import AddBookingModal from './components/BookingManagmentModal';
import { Booking } from './models';

const BookingManagement = () => {
  const [selectedTab, setSelectedTab] = useState<string | null>(
    LIST_VIEW.TABLE_VIEW
  );
  const [open, setOpen] = useState<boolean>(false);
  const [viewType, setViewType] = useState<string>(VIEW_TYPE.BOOKING_MANAGEMENT);
  const [isAddModal, setIsAddModal] = useState<boolean>(true);
  const navigate = useNavigate();
  const { t } = useTranslation(I18N.DEFAULT);
  const dispatch = useDispatch<any>();
  const [bookingList, setBookingList] = useState([]);
  const {
    tenantAssetList
  } = useSelector(assetService.selectorAssetState);
  const {
    bookingData,
    selectedBokingData,
    isBookingListUpdated,
    isError,
    isBookingSave,
    errorMessage,
  } = useSelector(bookingService.selectorBookingManagementState);
  const { selectedOrganization, loginUserRole } = useSelector(selectUserState);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [breadcrumbsHeading, setBreadcrumbsHeading] = useState(t('booking-d-lite'));
  const [headerSubtitle, setHeaderSubtitle] = useState(t('booking-d-lite'));
  const [selectedUser, setSelectedUser] = useState();
  const [assetList, setAssetList] = useState([]);
  const {
    assetGroupData
  } = useSelector(assetGroupService.selectorAssetGroupState);
  const [assetGroupList, setAssetGroupList] = useState([]);
  const location = useLocation();
  const [params] = useSearchParams();

  useEffect(() => {
    findDeaultData();
  }, []);

  const findDeaultData = async () => {
    dispatch(setSelectedBooking(null));
    await dispatch(getTenantBookingData({tenantId: selectedOrganization.id, isFuture: true}));
    dispatch(assetService.getAssetByTenantIdData({tenantId : selectedOrganization.id, isExpenses: false}));
    await dispatch(assetGroupService.getAssetGroupByTenantId(selectedOrganization.id));
    const breadcrumbsList = [
      {
        name: `organization`,
        route: `${ROUTES.ADMIN_LOGIN}${ROUTES.ORGANIZATION}`
      },
      {
        name: `${selectedOrganization.tenantName}`
      }
    ];
    setBreadcrumbs(breadcrumbsList);
  };

  useEffect(() => {
    if (isBookingListUpdated) {
      setOpen(false);      
      dispatch(getTenantBookingData({tenantId: selectedOrganization.id, isFuture: true}));
    }
  }, [isBookingListUpdated]);

  useEffect(() => {
    setAssetGroupList(assetGroupData);
  }, [assetGroupData]);

  useEffect(() => {
    let list = [];
    setAssetList(list);
    if (tenantAssetList?.length > 0) {
      for (let index = 0, length = tenantAssetList.length; index < length; ++index) {
          const thisElement = {...tenantAssetList[index]};
          const name : string = thisElement.name;
          const code : string = thisElement.code ? thisElement.code : '';
          const size : string = thisElement.size ? `${code ? '|' : ''} ${thisElement.size}` : '';
          thisElement.label = `${code} ${size} | ${name}`;
          list.push(thisElement);
      }
    }
    setAssetList(list);
  }, [tenantAssetList]);

  function setInitialHeaderDetail(
    viewType,
    breadcrumbsHeading,
    subtitle,
    breadcrumbs
  ) {
    setViewType(viewType);
    setBreadcrumbsHeading(breadcrumbsHeading);
    setBreadcrumbs(breadcrumbs);
    setHeaderSubtitle(subtitle);
  }

  useEffect(() => {
    setInitialHeaderDetail(
      VIEW_TYPE.BOOKING_MANAGEMENT,
      t('booking.bookingmanagement'),
      `${t('booking.list-all-booking-label')} ${selectedOrganization.tenantName}`,
      getBreadcrumbs(VIEW_TYPE.BOOKING_MANAGEMENT)
    );
  }, [location]);

  const getBreadcrumbs = (viewType) => {
    const breadcrumbs = [
      {
        name: t('organization'),
        route: `${ROUTES.ADMIN_LOGIN}${ROUTES.ORGANIZATION}`
      },
      {
        name: selectedOrganization.tenantName,
        route: ROUTES.BOOKING_MANAGEMENT
      }
    ];
    return viewType == VIEW_TYPE.BOOKING_MANAGEMENT
      ? breadcrumbs
      : [
        ...breadcrumbs,
        {
          name: params.get('user')
        }
      ];
  };

  useEffect(() => {
    if (isError) {
      dispatch(bookingService.setIsError(false));
      if (errorMessage !== '') {
        return showErrorMessage(errorMessage, {
          theme: 'colored',
          position: 'top-right',
          autoClose: 5000
        });
      }
    }
  }, [isError]);



  useEffect(() => {
    if (isBookingSave) {
      dispatch(bookingService.setIsBookingSave(false));
      setOpen(false)
    }
  }, [isBookingSave]);


  useEffect(() => {
    setBookingList(handleSortingBooking(true, bookingData));
  }, [bookingData]);

  const handleSortingBooking = (isFuture: boolean, bookingList) => {
    const updatedBookings = [];
    if (bookingList) {
      let list = [];
      const date: Date = new Date();
      let filteredBookingData = bookingList.filter(function (item) {
        const deliveryDate: Date = new Date(item.deliveryDate)
        return (
          isFuture ? deliveryDate > date : deliveryDate <= date
        )
      }).sort((a, b) => {
        return new Date(a.deliveryDate).getTime() - new Date(b.deliveryDate).getTime()
      }).map((booking) => {
        const deliveryDate: Date = new Date(booking.deliveryDate);
        const toDay: Date = new Date();
        const oneDay: Date = new Date(new Date().setDate(new Date().getDate() + 1));
        const twoDay: Date = new Date(new Date().setDate(new Date().getDate() + 2));
        const threeDay: Date = new Date(new Date().setDate(new Date().getDate() + 3));
        if (toDay <= deliveryDate && deliveryDate < oneDay && booking.bookingStatus === BOOKING_STATUS_ENUM.BOOKED) {
          return { ...booking, colorCode: COLOR_CODE.RED };
        } else if (toDay <= deliveryDate && deliveryDate < oneDay && booking.bookingStatus !== BOOKING_STATUS_ENUM.BOOKED) {
          return { ...booking, colorCode: COLOR_CODE.GREEN };
        } else if (toDay <= deliveryDate && deliveryDate < twoDay) {
          return { ...booking, colorCode: COLOR_CODE.YELLOW };
        } else if (toDay <= deliveryDate && deliveryDate < threeDay) {
          return { ...booking, colorCode: COLOR_CODE.GRAY };
        } else {
          return { ...booking, colorCode: COLOR_CODE.DEFAULT };
        }
      });

      list.push(...filteredBookingData);
      let filteredMissingBookingData = bookingList.filter(function (item) {
        const deliveryDate: Date = new Date(item.deliveryDate)
        return (
          !isFuture ? deliveryDate > date : deliveryDate <= date
        )
      }).sort((a, b) => {
        return new Date(a.deliveryDate).getTime() - new Date(b.deliveryDate).getTime()
      }).map((booking) => {
        return { ...booking, colorCode: COLOR_CODE.RED };
      });
      list.push(...filteredMissingBookingData);
      updatedBookings.push(...list);
    }
    return updatedBookings;
  }

  const handleFilterUsers = (value: string) => {
    const sortedBooking = handleSortingBooking(true, bookingData);
    const filteredBookingData = sortedBooking.filter(function (item) {
      return item.name?.toLowerCase().includes(value.toLowerCase()) ||
        item.billNo?.toLowerCase().includes(value.toLowerCase()) ||
        item.reference?.toLowerCase().includes(value.toLowerCase()) ||
        item.mobile?.toLowerCase().includes(value.toLowerCase()) ||
        item.bookingDate?.toLowerCase().includes(value.toLowerCase()) ||
        item.colorCode?.toLowerCase().includes(value.toLowerCase())
    });
    setBookingList(filteredBookingData);
  };

  useEffect(() => {
    if (selectedBokingData) {
      navigate(`${ROUTES.BOOKING_VIEW}`);
    }
  }, [selectedBokingData]);

  const handleAddUserButtonClick = () => {
    setIsAddModal(true);
    setOpen(true);
  };

  const handleViewIconClick = (row: any) => {
    dispatch(bookingService.setSelectedBooking(row));
  };
  const handleDeleteIconClick = (row: any) => { };

  const handleClose = (value) => {
    setOpen(false);
  };
  const closeDialog = () => {
    setOpen(false);
  };

  const onCancel = () => {
    closeDialog();
  };

  const handleEditIconClick = (row) => {
    setSelectedUser(row);
    setIsAddModal(false);
    setOpen(true);
  };

  const handleSwitchIconClick = (row) => {

  };

  const onSubmit = (values: any) => {
    const bookingValues = {...values};  
    bookingValues.tenantId = selectedOrganization.id;
    //setOpen(false);
    if (!isAddModal) {
      // As of now we did't provide edit functionality
    } else {
      dispatch(bookingService.addBooking(bookingValues));
    }
  };

  const handleViewOrientation = (
    _event: MouseEvent<HTMLElement>,
    newValue: string | null
  ) => {
    if (newValue !== null) {
      setSelectedTab(newValue);
    }
  };

  return (
    <>
      <Helmet>
        <title>Bookingdlite - Booking </title>
      </Helmet>
      <PageTitleWrapper>
        <PageHeader
          breadcrumbs={breadcrumbs}
          heading={breadcrumbsHeading}
          subHeading={headerSubtitle}
        >
          {viewType == VIEW_TYPE.BOOKING_MANAGEMENT && (
            <Button
              size={'small'}
              sx={{ pt: 1, pb: 1 }}
              className="letter-spacing"
              variant={'contained'}
              startIcon={<AddTwoToneIcon fontSize="small" />}
              onClick={handleAddUserButtonClick}
            >
              {t('booking.add-booking')}
            </Button>
          )}
          <TextField
            size={'small'}
            id="outlined-search"
            label={t('booking.search-booking-label')}
            type="search"
            onChange={(e) => handleFilterUsers(e.target.value)}
          />
          {/* <ToggleButtonGroup
            value={selectedTab}
            exclusive
            onChange={handleViewOrientation}
            size={'small'}
          >
            <ToggleButton disableRipple value={LIST_VIEW.CARD_VIEW}>
              <GridViewSharpIcon />
            </ToggleButton>
            <ToggleButton disableRipple value={LIST_VIEW.TABLE_VIEW}>
              <TableRowsTwoToneIcon />
            </ToggleButton>
          </ToggleButtonGroup> */}
        </PageHeader>
      </PageTitleWrapper>

      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            {!open ? <BookingManagementView
              handleDeleteIconClick={handleDeleteIconClick}
              handleViewIconClick={handleViewIconClick}
              handleSwitchIconClick={handleSwitchIconClick}
              handleEditIconClick={handleEditIconClick}
              inputUserData={bookingList}
              inputLoginUserRole={loginUserRole}
              inputSelectedTab={selectedTab}
              viewType={viewType}
            /> : <AddBookingModal
              isAddModal={isAddModal}
              open={open}
              assetGroupList={assetGroupList}
              assetList={assetList}
              onClose={handleClose}
              onSubmit={onSubmit}
              handleClose={handleClose}
              editObject={selectedUser}
            ></AddBookingModal>}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default BookingManagement;
